import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full bg-gray-50 border-t border-gray-200 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">스위치업랩</h3>
            <div className="space-y-2 text-sm text-gray-600">
              <p>대표자: 김은호</p>
              <p>사업자 등록번호: 170-02-03014</p>
              <p>통신판매업 신고: 통신판매 신고 제2024-의정부송산-0310</p>
            </div>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">고객 지원</h3>
            <div className="space-y-2 text-sm text-gray-600">
              <p>고객센터: 010-4141-8235</p>
              <p>주소: 서울 특별시 관악구 쑥고개로21길 29</p>
              <div className="pt-4 space-x-4">
                <Link to="/terms" className="text-blue-600 hover:text-blue-800">
                  서비스 이용약관
                </Link>
                <span className="text-gray-300">|</span>
                <Link to="/privacy" className="text-blue-600 hover:text-blue-800">
                  개인정보 처리방침
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 text-center">
            © {new Date().getFullYear()} 스위치업랩. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;